module.exports = __webpack_public_path__ + "img/fluent_payment-20-filled.d22500a7.png";